<div class="multiselect-dropdown wd-100">
  <div #dropdownOrigin class="dropdown-wrapper wd-100">
    <div
      class="dropdown-box flex_sb top-border-radius wd-100 h-100"
      [ngClass]="{
        'bottom-border-radius': !isOpen,
        'dropdown-selected': isFilterMode && selectedItemsCount > 0,
        'selected-border': !isOpen && isFilterMode && selectedItemsCount > 0
      }"
      [style]="style"
      (click)="toggleDropdown()"
    >
      <ng-container
        *ngIf="selectedItemsCount > 0 || !placeholder; else placeholderTemplate"
      >
        <span class="clr-333">{{ dropdownName }}</span>
      </ng-container>
      <ng-template #placeholderTemplate>
        <span class="clr-333">{{ placeholder }}</span>
      </ng-template>
      <span class="m-l-8">
        <span
          *ngIf="selectedItemsCount > 0"
          class="selected-count fs-16 fw-400 lh-140"
          [ngClass]="isFilterMode ? 'bg-fff' : 'selected-count-filter'"
        >
          {{ selectedItemsCount }}
        </span>
        <span
          class="dropdown-arrow m-l-4 fs-12 clr-666"
          [ngClass]="{ rotated: isOpen }"
          nz-icon
          nzType="down"
          nzTheme="outline"
        >
        </span>
      </span>
    </div>
  </div>

  <!-- Dropdown Content Template -->
  <ng-template #dropdownTemplate>
    <div class="dropdown-list bottom-border-radius">
      <ng-container *ngIf="allOptions?.length; else noDataFound">
        <!-- Search Functioanlity -->
        <div *ngIf="searchEnable" class="filter-textbox">
          <nz-input-group
            [nzPrefix]="prefixIconSearch"
            [nzSuffix]="searchText ? clearIconInput : ''"
            nzSize="large"
          >
            <input
              class="wd-100"
              type="search"
              nz-input
              [(ngModel)]="searchText"
              (ngModelChange)="onFilterTextChange($event)"
              [placeholder]="'Search'"
            />
          </nz-input-group>
          <ng-template #prefixIconSearch>
            <span
              class="fs-20 m-r-4 clr-999"
              nz-icon
              nzType="search"
              nzTheme="outline"
            ></span>
          </ng-template>
          <ng-template #clearIconInput>
            <span
              nz-icon
              class="fs-16 c-pointer clr-999"
              nzTheme="outline"
              nzType="close-circle"
              (click)="emptySearchFilter()"
            ></span>
          </ng-template>
        </div>

        <!-- Select All Feature -->
        <div
          *ngIf="selectAllEnable && !searchText"
          class="select-all-container"
        >
          <label class="option-label wd-100 flex-align-center c-pointer">
            <input
              type="checkbox"
              class="custom-checkbox flex-align-center"
              [(ngModel)]="allSelected"
              (ngModelChange)="toggleSelectAll()"
            />
            {{ allSelected ? 'Deselect All' : 'Select All' }}
          </label>
        </div>
        <!-- Display filtered dropdown options using virtual scrolling -->
        <ng-container *ngIf="filteredOptions?.length; else noDataFound">
          <cdk-virtual-scroll-viewport
            itemSize="48"
            class="viewport"
            [style.height.px]="viewportHeight"
          >
            <ul>
              <li
                class="dropdown-option"
                *cdkVirtualFor="let option of filteredOptions"
              >
                <label class="option-label wd-100 flex-align-center c-pointer">
                  <input
                    type="checkbox"
                    class="custom-checkbox"
                    [disabled]="option?.isDisabled"
                    [(ngModel)]="option.isSelected"
                    (ngModelChange)="onOptionClick(option)"
                  />
                  {{ option[labelKey] }}
                </label>
              </li>
            </ul>
          </cdk-virtual-scroll-viewport>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</div>

<!-- Template for when there is no data to display -->
<ng-template #noDataFound>
  <div class="p-l-16 p-t-16 p-b-16 p-r-16 ta_center">
    <img [src]="images?.NO_DROPDOWN_DATA" alt="no data" />
    <div class="fs-14 lh-130 fw-600 clr-666 m-t-8">No Data Available!</div>
  </div>
</ng-template>
